import type { ContractDeleteResponse } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UseInvoicesOverviewsPayload = Parameters<WeftApi['deleteContract']>[0];

export function useDeleteContract(
  options?: UseMutationOptions<ContractDeleteResponse, unknown, UseInvoicesOverviewsPayload['contractId']>,
) {
  const api = getPrivateApi();

  return useMutation((contractId) => api.deleteContract({ contractId }), options);
}
